import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import RightSidebarPaper from '../../../../components/ui-component/form-component/right-side-bar/RightSidebarPaper';
import { Typography } from '@mui/material';
import { enumT } from '../../../../utils/helper';
import { get } from 'lodash';
import { DisplayDateTime, DisplayEuro } from '../../../../utils/formats';

import Schema from '../../../../lib/paths/mittelabruf_FULL_Paths.json';
const P = Schema.attributes;

const MittelabrufSidebar: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<RightSidebarPaper>
				<span>
					<Typography variant="subtitle2">Art des Antrags:</Typography>
					<Typography variant="body1">Mittelabruf</Typography>
				</span>

				<span>
					<Typography variant="subtitle2">Mittelabruf Nr.:</Typography>
					<Typography variant="body1">{enumT(get(application, P.Allgemein_Nr.path, 'ausstehend'))}</Typography>
				</span>

				<span>
					<Typography variant="subtitle2">Status:</Typography>
					<Typography variant="body1">{enumT(get(application, P.Mittelabrufstatus_Mittelabrufstatus.path))}</Typography>
				</span>

				<span>
					<Typography variant="subtitle2">Beantragte Förderung:</Typography>
					<Typography variant="body1">
						{DisplayEuro(
							get(application, P.Zuwendungsantrag.schema.attributes.Zusammenfassung_Foerdersumme_Geplant.path, ''),
						)}
					</Typography>
				</span>

				<span>
					<Typography variant="subtitle2">Bewilligte Förderung:</Typography>
					<Typography variant="body1">
						{DisplayEuro(
							get(application, P.Zuwendungsantrag.schema.attributes.Zusammenfassung_Foerdersumme_Bewilligt.path, ''),
						)}
					</Typography>
				</span>
				<span>
					<Typography variant="subtitle2">Erstellt am:</Typography>
					<Typography variant="body1">{DisplayDateTime(get(application, 'attributes.createdAt'))}</Typography>
				</span>
				<span>
					<Typography variant="subtitle2">Zuletzt geändert am:</Typography>
					<Typography variant="body1">{DisplayDateTime(get(application, 'attributes.updatedAt'))}</Typography>
				</span>
			</RightSidebarPaper>
		</>
	);
};
export default MittelabrufSidebar;
